<template>
  <div class="question-container">
    <!-- PREVIEW Mode -->
    <div v-if="mode == 0">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
        </div>
        <div class="col-md-7 p-0">
          <div class="row p-0 m-0 mt-5">
            <template v-if="answer && answer.answerText">
              <img width="100%" height="210px" src="static/img/activity-configurator/Wong_baker_black_face.jpg" class="wong-baker-smiley wong-baker-img d-block text-center" alt="hurts-worse.svg" />
              <div class="text-center mx-auto mt-32 wong-baker-count-box">
                <input type="number" class="wong-baker-count d-block mx-auto " v-model="updatedAns" disabled="disabled" placeholder="" />
              </div>
            </template>
          </div>
        </div>
        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div v-if="question.isSkippable" class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- EDIT MODE -->
    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
          <span v-if="isQuestionSkipped()" class="skipped-question-box ml-15 d-inline-box pt-2">
            Skipped
          </span>
        </div>
        <div class="col-md-7 p-0" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <div class="row p-0 m-0 mt-5">
            <img width="100%" height="210px" src="static/img/activity-configurator/Wong_baker_black_face.jpg" class="wong-baker-smiley wong-baker-img d-block text-center" alt="hurts-worse.svg" />
            <div class="text-center mx-auto mt-32 wong-baker-count-box">
              <input :disabled="answer && answer.isDisabled == true" type="number" class="wong-baker-count d-block mx-auto" :class="{ 'is-danger': hasFieldError }" v-model="updatedAns" @change="updateInputScore" placeholder="" onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57" />
              <span class="error-style" v-if="hasFieldError">{{ fieldErrorText }}</span>
              <span class="error-style" v-else-if="hasFieldWarning">{{ fieldWarningText }}</span>
            </div>
          </div>
        </div>
        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- RESPONSE MODE -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="answer && answer.edit_status == 1"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <template v-if="answer && answer.answer_text">
              <div class="col-md-12 d-flex pl-30">
                <div class="wong-baker-count-box">
                  {{ answer.answer_text }}
                </div>
              </div>
              <div class="row">
                <div class="d-inline-block ml-25 pt-10" v-if="showScore && activityType == 'activity' && answer.score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="answer && answer.edit_status == 1">
          <div v-if="answer && answer.edit_status == 1">
            <div class="row">
              <div class="d-inline-block ml-25 pt-10">
                <span class="previous-value-mark"></span>
                <div class="previous-value ml-3">PREVIOUS RESPONSE</div>
                <template v-if="answer && answer.privius_answer_text">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="mx-auto wong-baker-count-box pt-2">
                        {{ answer.privius_answer_text }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="d-inline-block ml-0 pt-6" v-if="showScore && answer.privius_score != null">
                      <label>Score</label>
                      <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                        {{ answer.privius_score }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="question.isSkippable">
                  <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                    <label class="fs-12">Score</label>
                    <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                      {{ question.skipScore || 0 }}
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
export default {
  name: "WongBakerResponse",
  mixins: [activityCommonMixin],
  data() {
    return {
      hasFieldError: "",
      checkField: this.updatedAns,
      fieldErrorText: "",
      updatedAns: "",
      hasFieldWarning: false,
      fieldWarningText: ""
    };
  },
  props: {
    mode: Number,
    answer: Object,
    usage: Object,
    surveyData: Object,
    stepIndex: Number,
    question: Object,
    selectedLanguageCulture: String,
    activityType: String
  },
  watch: {
    checkField() {
      this.updateInputScore();
    },
    mode: {
      handler(value) {
        if (value == 0) {
          this.updatedAns = this.answer.answerText;
        }
      }
    }
  },
  mounted() {
    if (this.answer && this.answer.answerText) {
      this.updatedAns = this.answer.answerText;
      this.$set(this.answer, "score", parseInt(this.answer.answerText));
      if (this.answer.computedScore == 0) {
        this.$set(this.answer, "computedScore", parseInt(this.answer.score));
      }
    }
  },
  methods: {
    updateInputScore() {
      const wongAnswer = ["0", "2", "4", "6", "8", "10"];

      this.checkForFieldErrors(wongAnswer);

      if (this.answer && !this.hasFieldError) {
        this.$set(this.answer, "answerText", `${this.updatedAns}`);
        this.answer.score = parseInt(this.updatedAns);
        this.answer.computedScore = this.answer.score;
      }

      if (this.answer && this.answer.answerText && wongAnswer.includes(this.answer.answerText)) {
        this.$emit("answerChanged", {
          questionId: this.answer.questionId,
          newAns: this.updatedAns
        });
      }
    },
    checkForFieldErrors(wongAnswer) {
      this.resetAllErrors();

      this.question.dataChecks = [];
      if (this.question.dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && this.updatedAns == "") {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `This field is required.`;
              this.question.isSkippable = true;
              softDataCheck = true;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: this.fieldWarningText
              });

              return false;
            }
          } else {
            if (this.question.dataEditChecks[k].type == "NOT_BLANK" && this.updatedAns == "") {
              this.hasFieldError = true;
              this.hasFieldWarning = false;
              this.fieldErrorText = "This field is required.";
              this.question.isSkippable = false;
              return false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }

      if (this.answer) {
        if (this.updatedAns == "") {
          this.question.hasFieldError = true;
          this.hasFieldError = true;
          this.fieldErrorText = `This field is required.`;
          return;
        } else if (wongAnswer.includes(this.updatedAns) == false) {
          this.question.hasFieldError = true;
          this.hasFieldError = true;
          this.fieldErrorText = `Please enter correct input.`;
          return;
        }
      }
      this.hasFieldError = false;
    },
    resetAllErrors() {
      this.question.hasFieldError = false;
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}

.question-text {
  display: inline;
}

.previous-value-mark {
  width: 9px;
  height: 51px;
  background-color: #f5a623;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.previous-value {
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #f5a623;
  margin-bottom: 9px;
  margin-top: 3px;
}

.answers {
  font-weight: 600;
  color: #000000;
}

.wong-baker-img {
  width: 100%;
  height: 210px;
}
.wong-baker-count {
  width: 60px;
  height: 59px;
  padding: 19px 16px;
  text-align: center;
  border-radius: 8px;
  border: solid 1px #b0bac9;
  font-size: 24px;
  font-weight: 500;
  line-height: 0.92;
  letter-spacing: -0.41px;
  text-align: center;
  color: #666669;
}
.wong-baker-count-box input[type="number"]::placeholder {
  font-size: 22px;
  font-weight: 500;
  line-height: 0.92;
  letter-spacing: -0.41px;
  text-align: center;
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}
</style>
